import { createContext, useContext } from 'react';
import { ModelsFundraisingEventModel as FundraisingEvent } from '../../api/agency-api';

export const ActiveEventContext = createContext<FundraisingEvent | null>(null);

export const useActiveEvent = () => useContext(ActiveEventContext);
